// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// SSR-safe storage wrapper — localStorage is unavailable during prerender
const ssrSafeStorage = typeof window !== "undefined"
  ? localStorage
  : {
      getItem: () => null,
      setItem: () => {},
      removeItem: () => {},
    };

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: ssrSafeStorage as any,
    persistSession: true,
    autoRefreshToken: true,
  }
});